import type { AttributeField } from "@/features/properties/types/propertyAttributes";

/**
 * A field in attribute_templates.schema_definition. Besides the core props,
 * templates may carry options, required, r1Scope, reference, hint — all of
 * which must be preserved on the created survey fields.
 */
export interface TemplateFieldDef {
  id: string;
  type: string;
  title: string;
  fields?: TemplateFieldDef[];
  [key: string]: unknown;
}

/**
 * Builds an empty survey `data` tree from a template's schema_definition,
 * mirroring the Flutter app's upload payload shape: every template prop is
 * kept, leaves get `value: null`, and `ref_id` is set to the template field
 * id so normalization can match fields across surveys.
 */
export function buildEmptySurveyData(fields: TemplateFieldDef[]): AttributeField[] {
  return fields.map((field) => {
    if (field.type === "node") {
      const { fields: children, ...rest } = field;
      // The editor iterates `fields` on every node without guarding, so a
      // node must always carry an array even if the template had none.
      return {
        ...rest,
        ref_id: field.id,
        fields: Array.isArray(children) ? buildEmptySurveyData(children) : [],
      } as unknown as AttributeField;
    }

    return {
      ...field,
      ref_id: field.id,
      value: null,
    } as unknown as AttributeField;
  });
}
